import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { subscriptionsPlansAPI } from '../../ApiCalls/Dashboard/SubscriptionAPI';
import { EventState } from '../../Slice/Dashboard/EventSlice';
import { createEventAPI, createEventNameAPI, deleteEventAPI, deleteEventNameAPI, deleteUserCreatedEventAPI, getAllEventsAPI, getEventAvailableMembers, getEventNamesAPI, getEventSchedulingStatsAPI, getUserCreatedEventsAPI, updateEventAPI } from '../../ApiCalls/Dashboard/EventAPI';
import { BackendEvent, CalendarSubEvents, EnteredSubEventType, EventType, UserCreatedEvents } from '../../../Data/event.dto';
import { showErrorToast, showSuccessToast } from '../../../components/atoms/Utlis/Toast';
import { trackClarityEvent } from '../../../analytics/ClarityAnalytics';
import { CLARITY_EVENTS } from '../../../analytics/EventTypes';
const findEventTimeRange = (subEvents: CalendarSubEvents[]): { startTime: string, endTime: string } => {
    if (subEvents.length === 0) {
        return { startTime: '', endTime: '' };
    }

    // Initialize with the first sub-event
    let startTime = new Date(subEvents[0].start_date + 'T' + subEvents[0].start_time);
    let endTime = new Date(subEvents[0].end_date + 'T' + subEvents[0].end_time);

    subEvents.forEach(subEvent => {
        const startDateTime = new Date(subEvent.start_date + 'T' + subEvent.start_time);
        const endDateTime = new Date(subEvent.end_date + 'T' + subEvent.end_time);

        if (startDateTime < startTime) {
            startTime = startDateTime;
        }

        if (endDateTime > endTime) {
            endTime = endDateTime;
        }
    });

    // Format the resulting Date objects to ISO 8601 string format
    const formattedStartTime = startTime.toString().slice(0, -1);
    const formattedEndTime = endTime.toString().slice(0, -1);
    // console.log({ startTime: formattedStartTime, endTime: formattedEndTime })
    return { startTime: formattedStartTime, endTime: formattedEndTime };
};

export const EventReducer = (builder: ActionReducerMapBuilder<EventState>) => {
    builder.addCase(getAllEventsAPI.pending, (state) => {
        state.loading = true;
        state.isError = false;
        state.success = false;
        state.error = {};
    })
        .addCase(getAllEventsAPI.fulfilled, (state, action: PayloadAction<BackendEvent[]>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.isEventUpdate = false;
            state.Events = [];
            action.payload.forEach(mainEvent => {
                let dateRange = findEventTimeRange(mainEvent.sub_events)
                state.Events.push({
                    id: mainEvent.id,
                    title: mainEvent.title,
                    members: mainEvent.members,
                    sub_events: mainEvent.sub_events,
                    start: dateRange.startTime,
                    end: dateRange.endTime,
                    branch_id: mainEvent.branch_id,
                    branch_name: mainEvent.branch_name,
                    customer: mainEvent.customer,
                    customer_name: mainEvent.customer_name ?? (mainEvent.customer as any)?.name ?? (mainEvent as any)?.customer_detail?.name ?? null,
                    customer_country_code: mainEvent.customer_country_code ?? (mainEvent.customer as any)?.country_code ?? (mainEvent as any)?.customer_detail?.country_code ?? '+91',
                    customer_phone: mainEvent.customer_phone ?? (mainEvent.customer as any)?.phone ?? (mainEvent as any)?.customer_detail?.phone ?? null,
                    customer_email: mainEvent.customer_email ?? (mainEvent.customer as any)?.email ?? (mainEvent as any)?.customer_detail?.email ?? null,
                })
            })
            // state.Events = action.payload;
        })
        .addCase(getAllEventsAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            state.isEventUpdate = false;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }

        }).addCase(createEventAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(createEventAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.isEventUpdate = true;
            showSuccessToast("Event Created Success")
            const payload = Array.isArray(action.payload) ? action.payload[0] : action.payload;
            trackClarityEvent(CLARITY_EVENTS.CALENDAR_EVENT_CREATED, {
                event_title: payload?.title,
                event_id: payload?.id,
                sub_events_count: payload?.sub_events?.length || 0,
            })
            // state.Events = action.payload;
        }).addCase(createEventAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(updateEventAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(updateEventAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.isEventUpdate = true;
            showSuccessToast("Event Updated Success")
            const payload = Array.isArray(action.payload) ? action.payload[0] : action.payload;
            trackClarityEvent(CLARITY_EVENTS.CALENDAR_EVENT_UPDATED, {
                event_title: payload?.title,
                event_id: payload?.id,
                sub_events_count: payload?.sub_events?.length || 0,
            })
            // state.Events = action.payload;
        }).addCase(updateEventAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(deleteEventAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(deleteEventAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            state.isEventUpdate = true;
            showSuccessToast('Event Deleted.')
            trackClarityEvent(CLARITY_EVENTS.CALENDAR_EVENT_DELETED, {
                event_id: action.meta?.arg?.id || action.payload?.id,
            })
            // state.Events = action.payload;
        })
        .addCase(deleteEventAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(getUserCreatedEventsAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            // state.error = {};
        })
        .addCase(getUserCreatedEventsAPI.fulfilled, (state, action: PayloadAction<{
            event: {
                id: string,
                customer_name: string,
                phone_number: string,
                token: string,
                event_name: string,
            },
            sub_events: EnteredSubEventType[]
        }[]>) => {
            state.loading = false;
            // console.log(action.payload)
            // console.log(action.payload)
            if (action.payload === null) state.userCreatedEvents = [];
            else {
                state.userCreatedEvents = [];
                action.payload.forEach(payload => {
                    state.userCreatedEvents?.push({
                        id: parseInt(payload.event.id),
                        customer_name: payload.event.customer_name,
                        phone_number: payload.event.phone_number,
                        token: payload.event.token,
                        event_name: payload.event.event_name,
                        sub_events: payload.sub_events,
                    })
                })
                // console.log(state.userCreatedEvents)
            }

            // state.Events = action.payload;
        })
        .addCase(getUserCreatedEventsAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(deleteUserCreatedEventAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            // state.error = {};
        })
        .addCase(deleteUserCreatedEventAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            delete state.userCreatedEvents;
            showSuccessToast("Event deleted successfully.")
            trackClarityEvent(CLARITY_EVENTS.USER_CREATED_EVENT_DELETED, {
                event_id: action.meta?.arg?.event_id || action.payload?.event_id,
            })
            // state.Events = action.payload;
        })
        .addCase(deleteUserCreatedEventAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })

        .addCase(getEventAvailableMembers.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.error = {};
        })
        .addCase(getEventAvailableMembers.fulfilled, (state, action: PayloadAction<[{
            id: string,
            country_code: string,
            phone_number: string,
            profile_image: string,
            name: string,
            job_type: string,
            user_id: string | null,
        }]
        >) => {
            state.loading = false;
            // state.isMemberFetched = true;

            // console.log(action.payload);
            state.availableMembers = action.payload;
        })
        .addCase(getEventAvailableMembers.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            // state.isMemberFetched = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })

        .addCase(getEventNamesAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.error = {};
        })
        .addCase(getEventNamesAPI.fulfilled, (state, action: PayloadAction<[]>) => {
            state.loading = false;
            state.eventNames = action.payload;
        })
        .addCase(getEventNamesAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })

        .addCase(createEventNameAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            state.error = {};
        })
        .addCase(createEventNameAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            state.isError = false;
            state.success = true;
            showSuccessToast("Event Name Created Success")
            trackClarityEvent(CLARITY_EVENTS.EVENT_NAME_CREATED, {
                event_name: action.meta?.arg?.event_name || action.payload?.event_name,
            })
        }).addCase(createEventNameAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })

        .addCase(deleteEventNameAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.success = false;
            // state.error = {};
        })
        .addCase(deleteEventNameAPI.fulfilled, (state, action: any) => {
            state.loading = false;
            // delete state.userCreatedEvents;
            showSuccessToast("Event deleted successfully.")
            trackClarityEvent(CLARITY_EVENTS.EVENT_NAME_DELETED, {
                event_ids: action.meta?.arg || action.payload?.event_ids || [],
            })
            // state.Events = action.payload;
        })
        .addCase(deleteEventNameAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })

        .addCase(getEventSchedulingStatsAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.event_scheduling = action.payload?.event_scheduling ?? null;
        });
};
